var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignupSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9545_1863)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 39,
    r: 39,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6722 25.438C59.4629 27.3395 59.4383 30.4012 57.623 32.2737L39.7994 50.6666C38.3164 52.2201 36.3565 53 34.3935 53C32.4306 53 30.4492 52.2136 28.9446 50.6409L20.4036 41.9713C18.5729 40.1117 18.5267 37.0532 20.302 35.1356C22.0804 33.218 24.9972 33.1729 26.8278 35.0292L34.3751 42.6932L51.1434 25.3896C52.9587 23.5139 55.8877 23.5429 57.6692 25.4412L57.6722 25.438Z",
    fill: "#595D61"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9545_1863"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 78,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupSelected);
export default __webpack_public_path__ + "static/media/signup-selected.2f8d0f5f3dce7b5d3caf9df93218ada5.svg";
export { ForwardRef as ReactComponent };